import { Spin } from 'antd';

export default function CustomSpin(props) {
	return (
		<>
			<Spin {...props} />
		</>
	);
}
